import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // Importar SweetAlert2
import './GenerarPedido.css';

const GenerarPedido = () => {
  const [sucursal, setSucursal] = useState("");
  const [almacen, setAlmacen] = useState("");
  const [descargando, setDescargando] = useState(false);
  const [periodoExtendido, setPeriodoExtendido] = useState(false);

  const generarPedido = async () => {
    if (!sucursal || !almacen) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Debes ingresar la sucursal y el almacén.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setDescargando(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/pedidos/generar-pedidos/`, {
        params: {
          sucursal,
          almacen,
          periodo_extendido: periodoExtendido
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `pedido_${sucursal}_${almacen}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      Swal.fire({
        title: "Pedido generado",
        text: `El pedido para la sucursal ${sucursal} y almacén ${almacen} se ha generado correctamente.`,
        icon: "success",
        confirmButtonText: "Aceptar",
      });

    } catch (err) {
      console.error("Error al generar el pedido:", err);
      Swal.fire({
        title: "Error al generar el pedido",
        text: "No se pudo generar el pedido. Verifica que existan datos para la sucursal y almacén especificados.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } finally {
      setDescargando(false);
    }
  };
  const almacenes = ["GC1", "GC2", "GP1", "GP2", "OFERTAS", "PD", "PEPSI-COCA"];
  return (
    <div className="generar-pedido-container" style={{ maxWidth: "500px", margin: "auto", padding: "20px" }}>
      <h2>Generar Pedido</h2>

      <label>Sucursal:</label>
      <input
        type="text"
        placeholder="Ej: 120-G"
        value={sucursal}
        onChange={(e) => setSucursal(e.target.value)}
        style={{ width: "90%", padding: "8px", marginBottom: "10px" }}
      />
      <select
        value={almacen}
        onChange={(e) => setAlmacen(e.target.value)}
        required
      >
        <option value="">ALMACEN</option>
        {almacenes.map((alm) => (
          <option key={alm} value={alm}>{alm}</option>
        ))}
      </select>
      {/* <label>Almacén:</label>
      <input
        type="text"
        placeholder="Ej: GC1"
        value={almacen}
        onChange={(e) => setAlmacen(e.target.value)}
        style={{ width: "90%", padding: "8px", marginBottom: "10px" }}
      />
      <div className="alerta-almacen">
          Ingresa el almacen como: GC1, GC2, GP1, GP2 u OFERTAS
      </div> */}
      <label style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "15px 0",
        padding: "10px 12px",
        backgroundColor: "#f5f5f5",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        border: "1px solid #e0e0e0"
      }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#efefef";
          e.currentTarget.style.borderColor = "#d0d0d0";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f5f5f5";
          e.currentTarget.style.borderColor = "#e0e0e0";
        }}>
        <input
          type="checkbox"
          checked={periodoExtendido}
          onChange={(e) => setPeriodoExtendido(e.target.checked)}
          style={{
            marginBottom: "8px",
            cursor: "pointer",
            width: "18px",
            height: "18px",
            accentColor: "#2196F3"
          }}
        />
        <span style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
          Usar período extendido
        </span>
      </label>
      <button onClick={generarPedido} disabled={descargando} style={{ padding: "10px 20px" }}>
        {descargando ? "Generando..." : "Generar y Descargar Pedido"}
      </button>
    </div>
  );
};

export default GenerarPedido;